import { IEmailTemplate, IPreviewEmailTemplatePayload } from "store/entities/email-template/interfaces";

import { BaseApi } from "../base";

export class EmailTemplateApi extends BaseApi {
  protected readonly prefix = "templates";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = () => this.get("");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchById = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (payload: Partial<IEmailTemplate>) => {
    const { id, ...rest } = payload;
    return this.patch(`${id}`, rest);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (payload: Partial<IEmailTemplate>) => this.post("", payload);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteTemplate = (id: string) => this.delete(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPreview = (payload: IPreviewEmailTemplatePayload) => this.post("preview", payload);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  test = (emails: string[], content: IEmailTemplate["content"], type: string) =>
    this.post("sendTestMessage", { recipients: emails, content, type });
}
